export const data = [
  {
    name: "Jan",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Feb",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Mar",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Apr",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "May",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Jun",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Jul",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Aug",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Sept",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Oct",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Nov",
    uv: 0,
    pv: 0,
    amt: 0,
  },
  {
    name: "Dec",
    uv: 0,
    pv: 0,
    amt: 0,
  },
];

export interface Transaction {
  id: string;
  paymentLinkId: string;
  productId: string;
  organizationId: string;
  quantity: number;
  price: number;
  amount: number;
  type: string;
  paymentFrom: string;
  payerEmail: string;
  productName: string;
  currency: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  reference: string;
  meta: Record<string, any>;
}
